import { formatDayMonthEuropeBerlin } from "@/utils/europeBerlinTime";

export interface TCetDateLabelProps {
    /** ISO date/datetime to render. Defaults to the current instant. */
    date?: string | Date;
    className?: string;
}

/**
 * "19th August · CET" — the Homepage v2 header date (design doc §7.1).
 *
 * Rendered from the server's `server_date` when available (board response),
 * falling back to the client's own clock otherwise. Always shown in
 * Europe/Berlin wall-clock time and labelled "CET" even during CEST, matching
 * the mock literally — see design doc §11 decision log.
 */
export function CetDateLabel({ date, className }: TCetDateLabelProps) {
    return (
        <div className={className}>
            <span className="text-2xl font-bold tracking-tight">
                {formatDayMonthEuropeBerlin(date)}
            </span>{" "}
            <span className="text-base font-normal text-muted-foreground">· CET</span>
        </div>
    );
}
